export default __webpack_public_path__ + "static/media/event.eaf6c0ed.svg";